module.exports = __webpack_public_path__ + "static/media/help-active.d9e4ee27.svg";